import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

function TotalValue({ value }) {
  return (
    <Paper sx={{ p: 3, mt: 3, textAlign: 'center', backgroundColor: 'background.paper', boxShadow: 3, borderRadius: 2 }}>
      <Typography variant="h4" component="h3">Total Value</Typography>
      <Typography variant="h2" component="h2" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
        {value?.toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }) || '₹0'}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Cumulative value of enquiries matching current filters.
      </Typography>
    </Paper>
  );
}

export default TotalValue;